<script>
export default {
  methods: {
    renderSiroko (question) {
      return question.replace(/\\begin\s*{wide}([\s\S]*?)\\end\s*{wide}/g, '<div class="wide">$1</div>')
    }
  }
}
</script>

<style>
.wide {
  overflow-x: auto;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// WideEquation.vue?726b18ce